export enum LoaderStatus {
    IDLE = 'idle', READING = 'reading', UPLOADING = 'uploading', ABORTED = 'aborted', ERROR = 'error'
}

export interface Loader {
    id: string;
    status: LoaderStatus;
    uploadTotal: null | number;
    uploaded: number;
    uploadedPercent: number;
    file: Promise<Blob>;
}

export interface IUploadAdapter {
    upload(): Promise<Record<'default', string | ArrayBuffer>>;
    abort(): Promise<void>;
}

export abstract class AbstractUploadAdapter implements IUploadAdapter {
    abstract upload(): ReturnType<IUploadAdapter['upload']>;
    abstract abort(): ReturnType<IUploadAdapter['abort']>;

    protected constructor(readonly loader: Loader) {}

    public getStatus(): LoaderStatus {
        return this.loader.status;
    }
}

export abstract class AbstractUploadPlugin {
    public abstract readonly uploadAdapter: new(loader: Loader) => IUploadAdapter;

    protected constructor(private readonly editor) {}

    private get editorFileRepository(): object {
        return this.editor.plugins.get('FileRepository');
    }
    private configureFileRepository(): void {
        this.editorFileRepository['createUploadAdapter'] = (loader: Loader) => new this.uploadAdapter(loader);
    }

    public init(): void {
        this.configureFileRepository();
    }
}
